import React from 'react';
import { CalculatorIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-blue px-4 py-24 text-center text-white" data-id="element-62" data-mp="3n4w8ryifi9ie">
      <Reveal className="mx-auto max-w-3xl" data-id="element-63" data-mp="3s2xsmlnoicux">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-teal/30 text-brand-orange" data-id="element-64" data-mp="welphkyr71w">
          <CalculatorIcon className="h-7 w-7" aria-hidden="true" data-id="element-65" data-mp="2zejy4fvstyo4" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-66" data-mp="34c235v6p3tqu">Ready to Bring Math to Every Classroom?</h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-67" data-mp="39beqeh1hb2ty">
          Start every math class already prepared, with a full year of lessons, practice, and assessments at your
          fingertips.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-lg" data-id="element-68" data-mp="2gmhmjiy0l8kq">GET THE MATH READY PACK</CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-69" data-mp="2lkswrus81l3h">Instant access · Print-ready · 30-day guarantee</p>
      </Reveal>
    </section>;
}